"use strict";
/*
 * Created on 04 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var commons_1 = require("../../../core/commons");

var SelloutReleaseItemWithPart_1 = require("../../model/sellout/SelloutReleaseItemWithPart");

var SelloutReleaseItemConverter_1 = require("./SelloutReleaseItemConverter");

var SelloutReleaseItemWithPartConverter_1 = require("./SelloutReleaseItemWithPartConverter");

var SelloutReleasePartConverter_1 = require("./SelloutReleasePartConverter");
/**
 * Implementation of {@link SelloutReleaseItemWithPartConverter}.
 *
 * @author JMe
 */


var SelloutReleaseItemWithPartConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemWi) {
  _inherits(SelloutReleaseItemWithPartConverterImpl, _SelloutReleaseItemWi);

  /**
   * @param releaseItemConverter
   * @param releasePartConverter
   */
  function SelloutReleaseItemWithPartConverterImpl(releaseItemConverter, releasePartConverter) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemWithPartConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemWithPartConverterImpl).call(this));
    _this.releaseItemConverter = releaseItemConverter;
    _this.releasePartConverter = releasePartConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutReleaseItemWithPartConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return commons_1.UNIMPLEMENTED('SelloutReleaseItemWithPartConverterImpl.toDocument'); // we should not need this.
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutReleaseItemWithPart_1.SelloutReleaseItemWithPart(conversions.asObject(source, 'releaseItem', function (document) {
        return _this2.releaseItemConverter.toObject(document, conversions);
      }), conversions.asObject(source, 'releasePart', function (document) {
        return _this2.releasePartConverter.toObject(document, conversions);
      }));
    }
  }]);

  return SelloutReleaseItemWithPartConverterImpl;
}(SelloutReleaseItemWithPartConverter_1.SelloutReleaseItemWithPartConverter);

SelloutReleaseItemWithPartConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutReleaseItemConverter_1.SelloutReleaseItemConverter, SelloutReleasePartConverter_1.SelloutReleasePartConverter])], SelloutReleaseItemWithPartConverterImpl);
exports.SelloutReleaseItemWithPartConverterImpl = SelloutReleaseItemWithPartConverterImpl;